import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { useIntl } from "react-intl";
import {
  Box,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Typography,
  Link
} from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    link: {
      "color": "#676769",
      "fontWeight": 600,
      "&:hover": {
        cursor: "pointer"
      }
    },
    dialogTitle: {
      margin: 0,
      padding: theme.spacing(2)
    },
    dialogTitleText: {
      color: theme.palette.pomagranatered.main,
      textAlign: "center",
      fontWeight: "bold"
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  })
);

function DataProcessingAgreementText() {
  const classes = useStyles();
  const intl = useIntl();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Box marginBottom={3}>
        <Typography>
          {intl.formatMessage({ id: "DATA_PROCESSING_AGREEMENT_TEXT_PART_1" })}
          <Link onClick={handleClickOpen} className={classes.link} underline="always">
            {intl.formatMessage({ id: "DATA_PROCESSING_AGREEMENT_LINK_TEXT" })}
          </Link>
          {intl.formatMessage({ id: "DATA_PROCESSING_AGREEMENT_TEXT_PART_2" })}
        </Typography>
      </Box>
      <Dialog open={open} onClose={handleClose} scroll="paper">
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <Typography className={classes.dialogTitleText} variant="subtitle1">
            {intl.formatMessage({ id: "DATA_PROCESSING_AGREEMENT_TEXT_TITLE" })}
          </Typography>
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers={true}>
          <Box
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage({ id: "DATA_PROCESSING_AGREEMENT_TEXT" })
            }}
          ></Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}

export default DataProcessingAgreementText;
